import { useQuery } from '@apollo/client';

import { GET_ALL_TENANT_FEATURE_FLAGS } from 'graphql/tenants/queries/getAllTenantFeatureFlags.gql';

export const useGetAllTenantFeatureFlags = (tenantId: number) => {
  return useQuery(GET_ALL_TENANT_FEATURE_FLAGS, {
    variables: {
      input: {
        tenantId,
      },
    },
    skip: !tenantId,
  });
};
